import { nanoid } from 'nanoid';
import React from 'react'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import FixedView from '../../components/FixedView';
import FormViewer from '../../components/FormViewer';
import FieldItem from '../../components/inputs/FieldItem';
import SelectInput from '../../components/inputs/SelectInput';
import TextAreaInput from '../../components/inputs/TextAreaInput';
import TextInput from '../../components/inputs/TextInput';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { getBoundingClientRect } from '../../utils/functions';
import { checkConditionGroup, checkTranslation, conditionalWidth, translate } from '../../utils/useful';
import MultiStage from './MultiStage';
import CAHeader from '../../components/header/CAHeader';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import DiagramPath from '../../components/views/diagram/DiagramPath';
import PermissionsView from '../../components/PermissionsView';
import StagesManager from '../../components/StagesManager';
import BottomSheet from '../../components/BottomSheet';
import AutomationTemplateSelect from './AutomationTemplateSelect';
import HttpServices from '../../utils/Http.services';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import { from } from 'jalali-moment';
import AutomationInfo from './AutomationInfo';

class AutomationAddNew extends React.Component {
    state = {

        steps: [

            { id: 'type', to: 'template', condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'workflow' } } } } },
            { id: 'type', to: 'template', condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'automation' } } } } },
            // { id: 'template', to: "info", condition: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.collectionInfo.workflowMode' }, operator: { value: '!=' }, target: { value: 'basic' } }, 2: { id: 2, source: { value: '@data.collectionInfo.workflowMode' }, operator: { value: '!=' }, target: { value: 'advanced' } } } } },

            { id: 'template', to: "info" },
            // { id: 'template', to: 'info' },

        ],


        currentStep: 'type',


        typeHeaders: [
            {
                type: 'ImageSelectInput', key: 'type', information: {
                    col: 2,
                    fontSize: 15,
                    FontWeight: 600,
                    padding: '10px',
                    type: 'local',
                    items: [
                        { title: '{{lang}}Workflow', image: '/assets/icons/useful/flow.png', value: 'workflow', description: 'Workflow is a type of automation which is focusing on creating and automating workflows and stages. There are 2 types for workflows, basic and advanced.' },
                        { title: '{{lang}}Automation', image: '/assets/icons/useful/robot.png', value: 'automation', description: 'Automations will can be used for automating and connecting any part of the system. Stages and workflows can not be used in this type.' },
                        // { title: '{{lang}}ca.Broadcast', image: '/assets/icons/useful/broadcast.png', value: 'broadcast', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                    ], placeholder: '{{lang}}Select The Hub ...', required: true
                },
            },
        ],


        modeHeaders: [
            {
                type: 'ImageSelectInput', key: 'mode', information: {
                    col: 2,
                    fontSize: 15,
                    FontWeight: 600,
                    padding: '10px',
                    type: 'local',
                    items: [
                        { title: '{{lang}}Basic', image: '/assets/icons/useful/timeline.png', value: 'basic', description: 'This can be used for simple workflows which does not need braches. This type is easy to manage but it has some limitation. It can later be converted to advanced.' },
                        { title: '{{lang}}Advance', image: '/assets/icons/useful/diagram.png', value: 'advanced', description: 'This option gives you advanced diagram editor to implement advanced and complicated workflows. This option can not be converted to basic mode.' },
                        // { title: '{{lang}}ca.Broadcast', image: '/assets/icons/useful/broadcast.png', value: 'broadcast', description: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit.' },
                    ], placeholder: '{{lang}}Select The Hub ...', required: true
                },
            },
        ],


        workflowInfoHeaders: [
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', placeholder: '{{lang}}ca.name', hint: "{{lang}}This workflow will be called by this name in the platform", required: true } },
            // TO DO: Needs a spesific API to get the frames which this user has access to their workflows management (Create). and the type of farme should be collection or other frames that can have workflow.
            { key: 'frames', type: 'MultiSelectInput', information: { isSearchable: true, label: '{{lang}}Frames', address: 'getFrames', filter: { applet: "{{appletId}}" }, fields: { title: 'name', value: '_id' }, type: 'api', root: '', placeholder: '{{lang}}Frames', required: false } },
            { key: 'default', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Make as default workflow', hint: 'If you turn on the option, this workflow will be used as the default workflow of the frames.', default: false, required: false } },
            { key: 'reusable', type: 'SwitchInput', col: '12', information: { label: '{{lang}}Can be used in other frames too', hint: 'If you turn on the option, this workflow can be used by other frames of this applet. Admins of other frames can add this workflow to their frames.', default: false, required: false } },
        ],

        automationInfoHeaders: [
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}Name', placeholder: '{{lang}}ca.name', hint: "{{lang}}This workflow will be called by this name in the platform", required: true } },
        ],


    }

    componentDidMount() {


        if (this.props.setHeader) {
            let obj = {
                'toolbar': null,
                'showToolbar': false,
                isPortal: true, doNotshowNotification: true,
                'title': "Create workflow | automation",
                create: true,
                // topHeaderComponent: this.topHeaderComponent,
                backAction: () => this.lastStage()
            }


            this.props.setHeader(obj)

        }

        let windowData = this.props.windowData
        let baseUrl = this.props.baseUrl
        let params = windowData?.params
        let type = params?.type
        let mode = params?.mode
        let frame = params?.frame

        let data = { type, mode }
        if (frame) {
            data.frames = [frame]
        }
        this.setState({ data })

        if (type && (type == 'workflow' || type == 'automation')) {

            if (type == 'workflow') {
                if (mode && (mode == 'basic' || mode == 'advanced')) {

                    this.changeStage('template')

                } else {

                    this.changeStage('mode')

                }
            }
            if (type == 'automation') {

                this.changeStage('template')
            }

        } else {
            this.changeStage('type')
        }

    }

    changeStage = (stage) => {
        this.stageManager.changeStage(stage)
        this.setState({ currentStage: stage })
    }


    lastStage = () => {
        if (this.state.currentStep == 'type' || this.state.currentStep == 0) {
            this.props.customBackAction()
        } else {
            this.stageManager.lastStage((stage) => {
                this.setState({ currentStep: stage }, () => {
                    this.props.setHeader("dummy", 1)
                })
            })
        }
    }




    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static',
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }


    topHeaderComponent = () => {
        return (
            <div className='flexc'>
                {this.state.currentStep == 'info' && (
                    <ButtonAnimated
                        iconwidth='24px'
                        onClick={this.postAutomation}
                        isLoading={this.state.isLoadingPost}
                        title={translate("Create")}
                        icon='/assets/icons/angle-right-white2.svg'
                        textColor={'#222'}
                        invert={!this.props.colors?.iconInvert}
                        bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                    />
                )}
            </div>

        )
    }


    postAutomation = () => {

        // if (this.infoForm && this.infoForm.getForm()) {
        // let form = this.infoForm.getForm()
        let page = this.props.page
        let body = { ...this.state.data,  ...page.postBody }
        // console.log(body)
        this.setState({ isLoadingPost: true })
        for (const [key, value] of Object.entries(body)) {
            if (/\{\{(.*?)\}\}/.test(value)) {
                let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                if (baseValue) {
                    if (this.props.variables) {
                        body[key] = this.props.variables[baseValue]
                    }
                }
            }
        }
        
        body.hub = this.props.variables?.appletHub

        if (body.type == 'automation') {
            body.mode = 'advanced'
        }

        // console.log(body)
        

        HttpServices.request("postFlow", body, (fetchResult, fetchError) => {

            this.setState({ isLoadingPost: false })

            if (fetchError || !fetchResult.info) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postFailed', description: fetchError?.message })
                return
            }

            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
            this.props.automationCreated(fetchResult.info)


        })
    }
    // }

    // nextStage = (rawData) => {
    //     if (this.props.customButtonAction && this.state.flowName.trim() != '') {
    //         this.props.customButtonAction(this.state.flowName, this.state.stages)
    //     } else {

    //         let data = this.props.initData
    //         if (!data.collectionInfo) {
    //             data.collectionInfo = {}
    //         }

    //         data.collectionInfo.automations = this.state.stages
    //         this.props.setData(data, () => {

    //             if (this.props.continue) {
    //                 this.props.continue(this.props.stageName)
    //             } else {
    //                 this.props.changeStage('userPrespective')
    //             }

    //         })
    //     }


    // }

    setData = (data, cb, refKey) => {
        let mainKey = refKey ?? 'data'
        let newData = this.state[mainKey]

        if (!newData) {
            newData = {}
        }


        for (const [key, value] of Object.entries(data)) {

            newData[key] = value
        }

        this.setState({ [mainKey]: newData }, () => {
            if (cb) { cb() }
        })
    }


    formLiveChange = (data, init, key, value, extra, full) => {
        if (!init) {
            let data = this.state.data ?? {}
            data[key] = value
            this.setState({ data }, () => {
                this.continue(this.state.currentStep)
            })
        }
    }


    continue = (currentStage) => {

        let steps = this.state.steps
        let data = this.state.data

        let nextStep

        if (steps) {

            steps.forEach(step => {

                if (step.id == currentStage && (!step.condition || checkConditionGroup(step.condition, { data }))) {
                    nextStep = step.to
                }
            })
        }

        if (nextStep) {
            this.stageManager.changeStage(nextStep)
            this.setState({ currentStep: nextStep }, () => {
                this.props.setHeader("dummy", 1)
            })
        }

    }

    continueBlank = () => {
        this.continue(this.state.currentStep)

    }

    selectTemplate = () => {
        this.continue(this.state.currentStep)
    }

    openTemplate = (item) => {
        this.setState({ selectedTemplate: item })
        this.bottomSheet.open()
    }



    render() {
        // let Ghost = this.state.ghost
        return (

            <div ref={el => this.pageContainer = el} className='h-100 w-100 window-content-radius scroll-no-scrollbar' style={{ backgroundColor: "#fff", position: 'relative', borderBottomRightRadius: '10px' }}>

                <StagesManager ref={el => this.stageManager = el} fast={true}  >
                    <div stage={0} stageName="type" className='flexc flex-column'>
                        <div className='p-3 w-100' style={{ maxWidth: 800 }}>

                            <div className='px-3 pt-3 mb-3 ' style={{}}>
                                <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('Choose type')}</h2>
                                <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("What type you are looking after?")}</p>
                            </div>


                            <div className='mt-2' >
                                <FormViewer ref={el => this.form = el} liveChange={this.formLiveChange} initData={this.props.initData} headers={this.state.typeHeaders} errors={this.state.errors} inputClass={' single-big  color-dark-blue-1'} nopadding={true} width={this.props.width} />
                            </div>

                        </div>
                    </div>



                    <div stage={1} stageName="mode" className='flexc flex-column'>
                        <div className='p-3 w-100' style={{ maxWidth: 800 }}>

                            <div className='px-3 pt-3 mb-3 ' style={{}}>
                                <h2 className=" text-semibig mb-0 color-dark-blue-1" >{translate('Choose stage type')}</h2>
                                <p className="mt-1 text-small color-dark-blue-1 max-width-500" >{translate("What type of stage you are looking after?")}</p>
                            </div>

                            <div className='mt-2' >
                                <FormViewer ref={el => this.form = el} liveChange={this.formLiveChange} initData={this.props.initData} headers={this.state.modeHeaders} errors={this.state.errors} inputClass={' single-big  color-dark-blue-1'} nopadding={true} width={this.props.width} />
                            </div>

                        </div>
                    </div>

                    <AutomationTemplateSelect stage={2} stageName="template" initData={this.state.data} width={this.props.width} continue={this.continue} setHeader={this.props.setHeader} variables={this.props.variables} setData={this.setData} fieldKey={'mode'}/>


                    <AutomationInfo stage={2} stageName="info" initData={this.state.data} width={this.props.width} continue={this.continue} setHeader={this.props.setHeader} variables={this.props.variables} setData={this.setData} postAutomation={this.postAutomation} />

                    {/* <div stage={2} stageName="info">
                        <div className='px-1 flexcc' style={{}}>
                            <div className='px-4 mt-2 pt-3' style={{ position: 'relative' }}>
                                <div>
                                    <div className='d-flex flex-wrap mt-3' style={{ maxWidth: 600 }}>
                                        <div className='px-3 mb-3'>
                                            <h2 className="text-semibig mb-0  color-dark-blue-1" style={{}} >{translate('Workflow information')}</h2>
                                            <p className="mt-0 text-smaller mt-1 mb-0  " style={{ color: '#212529' }} >{translate('You will see your applet with these data that you provide. You can change them later')}</p>
                                        </div>
                                        <FormViewer ref={el => this.infoForm = el} headers={this.state.data?.type == 'workflow' ? this.state.workflowInfoHeaders : this.state.automationInfoHeaders} initData={this.state.data} errors={this.state.errors} formClass={"bordered-form"} inputClass={'bordered-input'} variables={this.props.variables} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                </StagesManager>
            </div>
        )
    }
}

// export default AutomationAddNew;
const mapStateToProps = state => ({ settings: state.settings })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomationAddNew)
